export default __webpack_public_path__ + "static/media/tribe.cf2ba464.svg";